module.exports = "A grouped list (`GroupedList`) allows you to render a set of items as multiple lists with various grouping properties.\n"